import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema, type BusinessInformation } from './types/businessInformation';

export const BACKGROUND_THEATER_CONTENT_PATH = 'licenses.steps.businessInformation.forms.backgroundTheater';

export const backgroundTheaterSchema = BasicBusinessInformationSchema.extend({
  theaterName: z
    .string({
      required_error: `${BACKGROUND_THEATER_CONTENT_PATH}.theaterName.validation.required`,
    })
    .min(1, { message: `${BACKGROUND_THEATER_CONTENT_PATH}.theaterName.validation.required` }),
  seatCount: z
    .number({
      required_error: `${BACKGROUND_THEATER_CONTENT_PATH}.seatCount.validation.required`,
      invalid_type_error: `${BACKGROUND_THEATER_CONTENT_PATH}.seatCount.validation.required`,
    })
    .int({ message: `${BACKGROUND_THEATER_CONTENT_PATH}.seatCount.validation.required` })
    .min(1, { message: `${BACKGROUND_THEATER_CONTENT_PATH}.seatCount.validation.minimum` }),
  hasFixedVenue: z
    .boolean({
      required_error: `${BACKGROUND_THEATER_CONTENT_PATH}.hasFixedVenue.validation.required`,
      invalid_type_error: `${BACKGROUND_THEATER_CONTENT_PATH}.hasFixedVenue.validation.required`,
    })
    .nullable()
    .refine(val => val !== null, {
      message: `${BACKGROUND_THEATER_CONTENT_PATH}.hasFixedVenue.validation.required`,
    }),
});

export type BackgroundTheaterForm = z.infer<typeof backgroundTheaterSchema>;

export const createBackgroundTheaterDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.BackgroundTheater,
  theaterName: '',
  hasFixedVenue: null,
});
